/**
 * @file 订单相关
 * @author caiguoqing
 */

import axiosInstance from "./axiosInstance";

// 获取待做的订单
export const getCampaignTodosApi = async (
  campaignId: string,
  filter: { cycleId: string; marketingStrategy: string }
) => {
  let url = `/ads/order/pending`;

  if (filter.marketingStrategy) {
    url = `/ads/order/pending?marketingStrategy=${filter.marketingStrategy}`;
  }

  try {
    // console.log('[indexxuan]: getTodos call', url, new Date());
    const response = await axiosInstance.post(url, {
      campaignId: +campaignId,
      ...filter,
    });
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取campaign下订单统计数据
export const getCampaignOrderStatsApi = async (
  campaignId: string,
  cycleId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${campaignId}/stats`,
      {
        cycleId,
      }
    );
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message || error?.error);
  }
};

// 获取所有订单
export const getAllOrderApi = async (campaignId: string, params: any) => {
  let url = `/ads/order/groupList`;
  if (params.marketingStrategy) {
    url = `/ads/order/groupList?marketingStrategy=${params.marketingStrategy}`;
  }

  try {
    const response = await axiosInstance.post(url, {
      campaignId: +campaignId,
      ...params,
    });
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 查询订单todo列表
export const getTodoOrderApi = async () => {
  try {
    const response = await axiosInstance.get(`/ads/order/todo`);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取订单详情
// GET /ads/order/{id}
export const getOrderDetailApi = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/ads/order/${id}`);
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 通过达人
// POST /ads/order/{id}/confirm
export const confirmOrderApi = async (id: string, params: { lastBid?: number }) => {
  try {
    const response = await axiosInstance.post(`/ads/order/${id}/confirm`, params);
    return response.data.data;
  } catch (error: any) {
    throw {
      code: error?.code,
      message: error?.message || error?.error,
    };
  }
};

// 拒绝达人
// POST /ads/order/{id}/reject
export const rejectOrderApi = async (id: string, reason: string[]) => {
  try {
    const response = await axiosInstance.post(`/ads/order/${id}/reject`, {
      reason,
    });
    return response.data.data;
  } catch (error: any) {
    return error;
  }
};

// 通过达人并增加预算
export const confirmAndIncBudgetApi = async (id: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${id}/confirmAndIncBudget`
    );
    return response.data.data;
  } catch (error: any) {
    return error;
  }
};

// 批量确认订单并增加预算
export const batchConfirmAndIncBudgetApi = async (params: {
  orderIds: string[];
  campaignId: string;
}) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/batchConfirmAndIncBudget`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    return error;
  }
};

// 查询付款状态 轮训
// POST /ads/order/{id}/confirm
export const getChargeStatusApi = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/ads/order/chargeStatus/${id}`);
    return response.data.data;
  } catch (error: any) {
    return error;
  }
};

// 确认稿件
// POST /ads/order/{id}/confirmDraft
export const confirmDraftOrderApi = async (
  id: string,
  params: { approveNote: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${id}/confirmDraft`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    return error;
  }
};

// 提交反馈
// POST /ads/order/{id}/feedback
export const feedbackOrderApi = async (
  id: string,
  feedback: { text: string; imageList: string[]; videoList: string[] }[],
  suggestion: { text: string; imageList: string[]; videoList: string[] }[]
) => {
  try {
    const response = await axiosInstance.post(`/ads/order/${id}/feedback`, {
      feedback,
      suggestion,
    });
    return response.data.data;
  } catch (error: any) {
    return error;
  }
};

// 延期
// POST /ads/order/{id}/postpone
export const postponeOrderApi = async (id: string) => {
  try {
    const response = await axiosInstance.post(`/ads/order/${id}/postpone`);
    return response.data.data;
  } catch (error: any) {
    return error;
  }
};

// 完成订单
// POST /ads/order/{id}/complete
export const completeOrderApi = async (id: string) => {
  try {
    const response = await axiosInstance.post(`/ads/order/${id}/complete`);
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

export const checkIntegrationStatus = async (
  campaignId: string,
  clientId: string
) => {
  try {
    const response = await axiosInstance.post(
      `/order/testTracking/${campaignId}`,
      { clientId }
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// feedback 上传图片、视频接口
export const feedbackMediaUploadApi = async (
  id: string,
  params: { key: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${id}/publicUploadLink`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 获取所有物流公司
export const getLogisticsCompanyApi = async () => {
  try {
    const response = await axiosInstance.get(`/ads/order/couriers`);
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};
// 提交物流订单号
export const trackingNumberApi = async (
  id: string,
  params: { courierCode: string; trackingNumber: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${id}/trackingNumber`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 校验物流订单号
export const checkTrackingNumberApi = async (params: {
  courierCode: string;
  trackingNumber: string;
}) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/checkTrackingNumber`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 创建聊天室
export const createImApi = async (id: string) => {
  try {
    const response = await axiosInstance.post(`/ads/im/group/${id}`, {});
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};
// 取消订单
export const cancelOrderApi = async (id: string) => {
  try {
    const response = await axiosInstance.post(`/ads/order/${id}/cancel`, {});
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};
// 订单反馈
export const orderFeedbackApi = async (
  orderId: string,
  params: { text: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/feedback/order/${orderId}`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 更改订单配置
export const changeOrderConfigApi = async (
  id: string,
  params: { isStar: boolean }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${id}/config`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 获取所有要求的达人
export const getInvitedCreatorList = async (
  campaignId: string,
  params: {
    paginate: { pageNum: number; pageLimit: number };
    name: string;
    marketingStrategy: string;
  }
) => {
  let url = `/ads/order/${campaignId}/invited`;

  if (params.marketingStrategy) {
    url = `/ads/order/${campaignId}/invited?marketingStrategy=${params.marketingStrategy}`;
  }

  try {
    const response = await axiosInstance.post(url, params);
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 举报达人
export const adsReportOrderApi = async (
  creatorId: string,
  params: { types: any; reason: string; urls: any }
) => {
  try {
    const response = await axiosInstance.post(
      `ads/feedback/influencer/${creatorId}/report`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// IM已读消息回调
export const imMessageReadApi = async (params: {
  userId: string;
  groupId: string;
}) => {
  try {
    const response = await axiosInstance.post(`api/mark-messages-read`, params);
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 获取Email outtreach
export const emailOuttreachLeadsInfoApi = async (campaignid: string) => {
  try {
    const response = await axiosInstance.get(
      `ads/campaign/${campaignid}/leadsInfo`
    );
    return response.data.data;
  } catch (error: any) {
    throw error;
  }
};

// 获取Email outtreach list
export const emailOuttreachListApi = async (
  campaignid: string,
  params: { paginate: { pageNum: number; pageLimit: number } }
) => {
  try {
    const response = await axiosInstance.post(
      `ads/campaign/${campaignid}/leads`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// 大客户获取campaign email sample
export const getCampaignEmailSampleApi = async (campaignid: string) => {
  try {
    const response = await axiosInstance.get(
      `ads/campaign/${campaignid}/emailSample`
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// 获取commission列表
export const getCommissionApi = async (
  campaignId: string,
  params: {
    paginate: { pageNum: number; pageLimit: number };
    cycleId: string;
    status: string;
    name: string;
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/commisions`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// 获取affiliate 订单价格
export const getCommissionChargeDetailApi = async (
  campaignId: string,
  params: {
    commisions: string[];
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/commisions/chargeDetail`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// 支付affiliate 订单
export const payCommissionApi = async (
  campaignId: string,
  params: {
    commisions: string[];
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/${campaignId}/commisions/pay`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// 广告主确认达人后，初步沟通创作方向
export const creativeDirectionApi = async (
  campaignId: string,
  params: {
    content: string;
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${campaignId}/creativeDirection`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
// 更新达人申请自动审核设置
export const updateApplyAutoReviewConfigApi = async (
  campaignId: string,
  params: {
    matchingScoreAbove: number;
    cpmBelow: any;
    cpcBelow: any;
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/campaign/v3/${campaignId}/updateApplyAutoReviewConfig`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// 下载达人列表
export const downloadCreatorListApi = async (params: any) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/groupList/download?marketingStrategy=${params.marketingStrategy}`,
      params,
      { responseType: "blob" }
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

// 计算传入的订单id数组，申请审核过的数量
export const getApplyReviewedCountApi = async (params: { ids: string[] }) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/getApplyReviewedCount`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// 获取传入的订单id数组的价格
export const getTotalChargeDetailApi = async (params: {
  orderIds: string[];
  campaignId: string;
}) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/getTotalChargeDetail`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

// 批量拒绝订单
export const batchRejectApi = async (params: {
  orderIds: React.Key[];
  campaignId: string;
  reason: string[];
}) => {
  try {
    const response = await axiosInstance.post(`/ads/order/batchReject`, params);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};
// 批量通过订单
export const batchConfirmOrderApi = async (params: {
  campaignId: string;
  orders?: { orderId: string; lastBid?: number }[];
}) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/batchConfirm`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw {
      code: error?.code,
      message: error?.message || error?.error,
    };
  }
};

// 审核达人申请延期
export const reviewPostponeApi = async (
  orderId: string,
  params: {
    approve: Boolean;
    reason?: string;
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${orderId}/reviewPostpone`,
      params
    );
    return response.data;
  } catch (error: any) {
    return error;
  }
};
// 评价订单
export const reviewOrderApi = async (
  orderId: string,
  params: {
    rating: number;
    comment: string;
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${orderId}/evaluate`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error?.message;
  }
};
// 查询评价
export const getReviewOrderApi = async (
  orderId: string,
  params: {
    paginate: {
      pageNum: number;
      pageLimit: number;
    };
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${orderId}/evaluations`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error?.message;
  }
};
// 编辑评价
export const editReviewOrderApi = async (
  orderId: string,
  params: {
    rating: number;
    comment: string;
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${orderId}/editEvaluation`,
      params
    );
    return response.data;
  } catch (error: any) {
    throw error?.message;
  }
};
// 删除评价
export const deleteReviewOrderApi = async (orderId: string) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${orderId}/deleteEvaluation`,
      {}
    );
    return response.data;
  } catch (error: any) {
    throw error?.message;
  }
};

// 获取待确认订单列表
export const getPendingInviteListApi = async (
  campaignId: string,
  params: {
    paginate: { pageNum: number; pageLimit: number };
    name: string;
    languages: string[];
    platforms: string[];
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${campaignId}/pendingInvite`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error?.message || error?.error;
  }
};
// 确认订单列表 批量邀约订单
export const batchConfirmInviteApi = async (params: {
  orderIds: string[];
  campaignId: string;
}) => {
  try {
    const response = await axiosInstance.post(`/ads/order/batchInvite`, params);
    return response.data.data;
  } catch (error: any) {
    throw error?.message || error?.error;
  }
};
// 确认订单列表 批量删除订单
export const batchDeleteInviteApi = async (params: {
  orderIds: string[];
  campaignId: string;
}) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/batchNotInvite`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error?.message || error?.error;
  }
};
// 确认订单列表 确认全部订单
export const confirmAllInvitesApi = async (params: { campaignId: string }) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/batchInviteAll`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error?.message || error?.error;
  }
};

// 下载确认订单列表
export const downloadConfirmedInviteListApi = async (
  campaignId: string,
  params: any
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${campaignId}/pendingInvite/download`,
      params,
      { responseType: "blob" }
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};
// 广告主确认达人后，设置账号信息
export const confirmAccessSetupApi = async (
  orderId: string,
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${orderId}/completeAccountSetup`,
      {}
    );
    return response.data.data;
  } catch (error: any) {
    throw error?.message || error?.error;
  }
};
// 广告主报价
export const confirmRateApi = async (
  orderId: string,
  params: {
    contentType: string;
    amount: number;
    nonNegotiable?: boolean;
    message?: string;
    lastBid?: number;
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${orderId}/negotiate`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw {
      code: error?.code,
      message: error?.message || error?.error,
    };
  }
};
// 提交达人链接
export const submitInfluencerLinkApi = async (
  orderId: string,
  params: {
    utmLink: string;
  }
) => {
  try {
    const response = await axiosInstance.post(
      `/ads/order/${orderId}/utmLink`,
      params
    );
    return response.data.data;
  } catch (error: any) {
    throw error?.message || error?.error;
  }
};
